import { BaseClient } from '@/api'

export class TuneClient extends BaseClient {
  constructor(
  ) {
    super('tunes')
  }
}
